import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const ValueProposition = () => {
  const outcomes = [
    "More stable placements",
    "Reduced re-hiring cycles",
    "Stronger cultural alignment",
    "Improved accountability",
    "Founder-level oversight on every shortlist"
  ];

  return (
    <section className="py-20 bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl font-normal text-black mb-6" style={{ fontFamily: "'DM Serif Display', serif", textShadow: 'none', WebkitFontSmoothing: 'antialiased' }}>
              Outcome-Led Recruitment
            </h2>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed" style={{ fontFamily: "'DM Serif Display', serif" }}>
              YuZu clients don't just receive CVs. They experience measurable improvement in hiring outcomes through structured, risk-focused screening.
            </p>
            
            <div className="space-y-3 mb-8">
              {outcomes.map((outcome, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle2 className="h-5 w-5 text-[#FFD000] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-gray-700">{outcome}</span>
                </div>
              ))}
            </div>

            <p className="text-gray-600 italic border-l-4 border-[#FFD000] pl-6 py-2 text-sm">
              "We assess. We filter. We validate. We present. Only aligned candidates reach your shortlist."
            </p>
          </div>

          <div className="relative">
            <img 
              src="https://images.unsplash.com/photo-1688999991699-332cd627bb36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBib3V0aXF1ZSUyMHNhZmFyaSUyMGxvZGdlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc2MDE1MTYwfDA&ixlib=rb-4.1.0&q=85"
              alt="Luxury Boutique Lodge Interior"
              className="rounded-lg shadow-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
